module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addRefIdText":"No reference id present"},"ja":{"addRefIdText":"管理IDが追加されていない"}}')
  delete Component.options._Ctor
}
